import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import Image from './Image';

export type PanelImageProps = PanelImageDto;
const styles = {
    container: {
        position: 'relative',
        height: 0,
        paddingBottom: '66.70%'
    },
    figure: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    }
};

type Props =
    PanelImageProps &
    StyledComponentProps<keyof typeof styles>;

const PanelImage = (props: Props) => {
    const { classes } = props;
    const sizes = "(max-width: 679px) 100w," +
    // "(min-width: 768px) and (max-width: 1199px) and (orientation: portrait) calc(100%/2)," +
    "(min-width: 680px) and (max-width: 994px) calc(50vw)," +
    "(min-width: 995px) and (max-width: 1439px) calc(100vw/6)"+
    "(min-width: 1440px) calc(100vw/6)";

    return (
        <div className={classes!.container}>
            <figure className={classes!.figure}>
                <Image 
                    pictureRef={props.Image}
                    sizes={sizes}
                    className={classes!.image}
                />
            </figure>
        </div>
    );
}

export default withStyles(styles)(PanelImage);


// WEBPACK FOOTER //
// ./src/components/PanelImage.tsx